"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.generateShowHourMinuteSecond = generateShowHourMinuteSecond;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TimePicker = _interopRequireDefault(require("rc-time-picker/lib/TimePicker"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _DatePicker = _interopRequireDefault(require("../DatePicker"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable no-console,func-names,react/no-multi-comp */
var TimePicker_ = _DatePicker.default.TimePicker;
function generateShowHourMinuteSecond(format) {
  // Ref: http://momentjs.com/docs/#/parsing/string-format/
  return {
    showHour: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
    showMinute: format.indexOf('m') > -1,
    showSecond: format.indexOf('s') > -1
  };
}
var Timepicker = /*#__PURE__*/function (_Component) {
  function Timepicker(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Timepicker);
    _this = _callSuper(this, Timepicker, [props]);
    (0, _defineProperty2.default)(_this, "handleChange", function (value) {
      if (!('value' in _this.props)) {
        _this.setState({
          value: value
        });
      }
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        _this$props$format = _this$props.format,
        format = _this$props$format === void 0 ? 'HH:mm:ss' : _this$props$format;
      if (onChange) {
        onChange(value, value && value.format(format) || '');
      }
    });
    (0, _defineProperty2.default)(_this, "handleOpenClose", function (_ref) {
      var open = _ref.open;
      var onOpenChange = _this.props.onOpenChange;
      if (onOpenChange) {
        onOpenChange(open);
      }
    });
    (0, _defineProperty2.default)(_this, "saveTimePicker", function (timePickerRef) {
      _this.timePickerRef = timePickerRef;
    });
    var _value = props.value || props.defaultValue;
    if (_value && !_moment.default.isMoment(_value)) {
      throw new Error('The value/defaultValue of TimePicker must be a moment object');
    }
    _this.state = {
      value: _value
    };
    return _this;
  }
  (0, _inherits2.default)(Timepicker, _Component);
  return (0, _createClass2.default)(Timepicker, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if ('value' in nextProps) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.timePickerRef.focus();
    }
  }, {
    key: "getDefaultFormat",
    value: function getDefaultFormat() {
      var _this$props2 = this.props,
        format = _this$props2.format,
        use12Hours = _this$props2.use12Hours;
      if (format) {
        return format;
      } else if (use12Hours) {
        return 'h:mm:ss a';
      }
      return 'HH:mm:ss';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var props = _objectSpread({}, this.props);
      delete props.defaultValue;
      var format = this.getDefaultFormat();
      var className = (0, _classnames.default)(props.className, (0, _defineProperty2.default)({}, "".concat(props.prefixCls, "-").concat(props.size), !!props.size));
      var addon = function addon(panel) {
        return props.addon ? /*#__PURE__*/_react.default.createElement("div", {
          className: "".concat(props.prefixCls, "-panel-addon")
        }, props.addon(panel)) : null;
      };
      var inputIcon = function inputIcon(kind) {
        return (_this2.props.disabled || !_this2.state.value) && /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: kind,
          className: "".concat(props.prefixCls, "-icon"),
          size: 20
        }) || undefined;
      };
      var clearIcon = function clearIcon(kind) {
        return /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: kind,
          className: "".concat(props.prefixCls, "-icon clear"),
          size: 20
        });
      };
      return /*#__PURE__*/_react.default.createElement(_TimePicker.default, (0, _extends2.default)({}, generateShowHourMinuteSecond(format), props, {
        ref: this.saveTimePicker,
        format: format,
        className: className,
        value: this.state.value,
        placeholder: props.placeholder === undefined ? props.placeholder : props.placeholder,
        onChange: this.handleChange,
        onOpen: this.handleOpenClose,
        onClose: this.handleOpenClose,
        addon: addon,
        inputIcon: inputIcon('clock-alt'),
        clearIcon: clearIcon('close')
      }));
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(Timepicker, "defaultProps", {
  prefixCls: 'ykb-time-picker',
  align: {
    offset: [0, -2]
  },
  disabled: false,
  disabledHours: undefined,
  disabledMinutes: undefined,
  disabledSeconds: undefined,
  hideDisabledOptions: false,
  placement: 'bottomLeft',
  transitionName: 'slide-up',
  allowEmpty: true,
  defaultValue: undefined,
  value: undefined,
  minuteStep: 1,
  secondStep: 1,
  showHour: true,
  showMinute: true,
  showSecond: true,
  focusOnOpen: false,
  use12Hours: false
});
var _default = exports.default = TimePicker_;
TimePicker_.propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  prefixCls: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  align: _propTypes.default.object,
  hideDisabledOptions: _propTypes.default.bool,
  placement: _propTypes.default.string,
  transitionName: _propTypes.default.string,
  disabledHours: _propTypes.default.func,
  disabledMinutes: _propTypes.default.func,
  disabledSeconds: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onOpen: _propTypes.default.func,
  defaultOpenValue: _propTypes.default.object,
  allowEmpty: _propTypes.default.bool,
  defaultValue: _propTypes.default.object,
  value: _propTypes.default.object,
  minuteStep: _propTypes.default.number,
  secondStep: _propTypes.default.number,
  showHour: _propTypes.default.bool,
  showMinute: _propTypes.default.bool,
  showSecond: _propTypes.default.bool,
  open: _propTypes.default.bool,
  focusOnOpen: _propTypes.default.bool,
  use12Hours: _propTypes.default.bool,
  format: _propTypes.default.string
};